<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-20 18:07:22
-->
<template>
	<div>
		<rdStatus :type="statusConfig.type">
			{{ statusConfig.label }}
		</rdStatus>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
import rdStatus from '@/components/ui/rdStatus';
export default {
	mixins: [mixin],
	computed: {
		statusConfig({ row }) {
			let status = {
				1: {
					label: '待审核',
					type: 'warning',
				},
				2: {
					label: '审核通过',
					type: 'success',
				},
				3: {
					label: '审核拒绝',
					type: 'error',
				},
				5: {
					label: '已失效',
					type: 'fail',
				},
			};
			return status[row.itemAuditStatus] || {};
		},
	},
	components: {
		rdStatus,
	},
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
</style>
